"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/echartsNew/index"));
var _priceSetting = require("@/api/priceSetting.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MonitorDetailModal',
  components: {
    echartsNew: _index.default
  },
  data: function data() {
    return {
      style: {
        height: '320px'
      },
      productId: null,
      skuId: null,
      dialogVisible: false,
      loading: false,
      tableLoading: false,
      recordId: null,
      detailInfo: {},
      recordList: [],
      recordTotal: 0,
      tableFrom: {
        page: 1,
        limit: 10
      },
      chartInstance: null,
      optionData: {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['添星价', '淘宝价', '京东价']
        },
        grid: {
          left: '2%',
          right: '2%',
          bottom: '2%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: 'value',
          name: '价格（元）'
        },
        series: [{
          name: '添星价',
          type: 'line',
          color: 'green',
          smooth: true,
          data: []
        }, {
          name: '淘宝价',
          type: 'line',
          color: 'red',
          smooth: true,
          data: []
        }, {
          name: '京东价',
          type: 'line',
          color: 'blue',
          smooth: true,
          data: []
        }]
      }
    };
  },
  methods: {
    // 打开弹框
    open: function () {
      var _open = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(productId, skuId) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.productId = productId;
              this.skuId = skuId;
              this.dialogVisible = true;
              this.tableFrom = {
                page: 1,
                limit: 10
              };
              _context.n = 1;
              return this.loadData();
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function open(_x, _x2) {
        return _open.apply(this, arguments);
      }
      return open;
    }(),
    // 加载数据
    loadData: function () {
      var _loadData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.loading = true;
              _context2.p = 1;
              _context2.n = 2;
              return Promise.all([this.loadDetail(), this.loadRecordList(), this.loadPriceTrend()]);
            case 2:
              _context2.p = 2;
              this.loading = false;
              return _context2.f(2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[1,, 2, 3]]);
      }));
      function loadData() {
        return _loadData.apply(this, arguments);
      }
      return loadData;
    }(),
    // 加载详情
    loadDetail: function () {
      var _loadDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return (0, _priceSetting.getMonitorRecordDetailApi)(this.productId, this.skuId);
            case 1:
              this.detailInfo = _context3.v;
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t = _context3.v;
              console.error('获取详情失败:', _t);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function loadDetail() {
        return _loadDetail.apply(this, arguments);
      }
      return loadDetail;
    }(),
    // 加载记录列表
    loadRecordList: function () {
      var _loadRecordList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              this.tableLoading = true;
              _context4.p = 1;
              _context4.n = 2;
              return (0, _priceSetting.getMonitorRecordListApi)(_objectSpread(_objectSpread({}, this.tableFrom), {}, {
                productId: this.productId,
                skuId: this.skuId
              }));
            case 2:
              res = _context4.v;
              this.recordList = res.list || [];
              this.recordTotal = res.total || 0;
              console.log(this.recordList);
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t2 = _context4.v;
              console.error('获取记录列表失败:', _t2);
            case 4:
              _context4.p = 4;
              this.tableLoading = false;
              return _context4.f(4);
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 3, 4, 5]]);
      }));
      function loadRecordList() {
        return _loadRecordList.apply(this, arguments);
      }
      return loadRecordList;
    }(),
    // 获取价格趋势
    loadPriceTrend: function () {
      var _loadPriceTrend = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res, _t3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              _context5.n = 1;
              return (0, _priceSetting.getPriceTrendApi)({
                productId: this.productId,
                skuId: this.skuId,
                limit: 7
              });
            case 1:
              res = _context5.v;
              this.optionData.xAxis.data = res.dateList;
              this.optionData.series[0].data = res.txPriceList;
              this.optionData.series[1].data = res.taobaoPriceList;
              this.optionData.series[2].data = res.jdPriceList;
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t3 = _context5.v;
              console.error('获取价格趋势失败:', _t3);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function loadPriceTrend() {
        return _loadPriceTrend.apply(this, arguments);
      }
      return loadPriceTrend;
    }(),
    // 分页
    handlePageChange: function handlePageChange(page) {
      this.tableFrom.page = page;
      this.loadRecordList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.tableFrom.limit = size;
      this.tableFrom.page = 1;
      this.loadRecordList();
    },
    // 格式化价格差异
    formatDiff: function formatDiff(diff, rate) {
      if (diff == null) return '-';
      var sign = diff >= 0 ? '+' : '';
      var rateStr = rate != null ? " (".concat(rate * 100, "%)") : '';
      return "".concat(sign).concat(diff).concat(rateStr);
    },
    // 获取差异样式
    getDiffClass: function getDiffClass(diff) {
      if (diff == null) return '';
      return diff > 0 ? 'text-up' : diff < 0 ? 'text-down' : '';
    },
    // 关闭弹框
    handleClose: function handleClose() {
      this.detailInfo = {};
      this.recordList = [];
      this.recordTotal = 0;
    }
  }
};